const listVariantClasses = 'paragraph-xs text-gray-350';
const linkVariantClasses = 'underline';
const linkContainerClasses = '';
const breadcrumbActiveClasses = '';
const breadcrumbLinkOpt = '';
const breadcrumbsCenterIcon = '';
const breadcrumbsContainer = '';
const breadcrumbsListClasses = 'mx-4 mb-8 box-content max-w-7xl md:mb-12 md:px-4 lg:mx-auto lg:px-8';
const breadcrumbTextOpt = '';

const breadcrumbsBlogTheme = {
  listVariantClasses,
  linkVariantClasses,
  linkContainerClasses,
  breadcrumbActiveClasses,
  breadcrumbLinkOpt,
  breadcrumbsCenterIcon,
  breadcrumbsContainer,
  breadcrumbsListClasses,
  breadcrumbTextOpt,
};

export default breadcrumbsBlogTheme;
